<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.66666 2C5.03486 2 5.33334 2.29848 5.33334 2.66666V8.66666C5.33334 9.77122 6.22876 10.6667 7.33334 10.6667H11.7239L10.8619 9.80474C10.6016 9.54438 10.6016 9.12228 10.8619 8.86192C11.1223 8.60158 11.5444 8.60158 11.8047 8.86192L13.8047 10.8619C14.0651 11.1223 14.0651 11.5444 13.8047 11.8047L11.8047 13.8047C11.5444 14.0651 11.1223 14.0651 10.8619 13.8047C10.6016 13.5444 10.6016 13.1223 10.8619 12.8619L11.7239 12H7.33334C5.49238 12 4 10.5076 4 8.66666V2.66666C4 2.29848 4.29848 2 4.66666 2Z"
      fill="#DF252A"
    />
  </svg>
</template>
